import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_STUDENT_COURSE, START_STUDENT_COURSE} from '../constants/student-course';
import {CREATE_REPORT} from '../constants/report';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_COURSE):
      return action.payload.course.homeworks.filter(({id}) => !action.payload.homeworks.includes(id));

    case getSuccessActionType(CREATE_REPORT):

      const homework_ids = action.payload.homeworks.map(homework => homework.id);
      return state.filter(homework => !homework_ids.includes(homework.id));

    case getSuccessActionType(START_STUDENT_COURSE):
      return action.payload.course.homeworks;

    default:
      return state;
  }
}

const actionTypes = [FETCH_STUDENT_COURSE, CREATE_REPORT, START_STUDENT_COURSE];

export default combineReducers({
  status: getStatusReducer(actionTypes),
  error: getErrorReducer(actionTypes),
  data
});
